import styled from 'styled-components';
export const SIGNUP_LINK_COLOR = '#0b8484';
export const StyledUILink = styled.span.withConfig({
  displayName: "TextInputstyles__StyledUILink",
  componentId: "sc-12ky935-0"
})(["color:", " !important;& svg{fill:", " !important;}"], SIGNUP_LINK_COLOR, SIGNUP_LINK_COLOR);